// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\r\n    --font-size: 12px;\r\n}\r\n\r\n.react-datepicker__day {\r\n    font-size: var(--font-size);\r\n    margin   : 0;\r\n}\r\n\r\n.react-datepicker__day-name {\r\n    font-size: var(--font-size);\r\n    margin   : 0;\r\n}\r\n\r\n.react-datepicker__month {\r\n    margin: 8px;\r\n}\r\n\r\n.react-datepicker-popper[data-placement^=\"bottom\"] {\r\n    margin-top: 0;\r\n}\r\n\r\n.react-datepicker {\r\n    border: 2px solid lightgray;\r\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
